// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class SmsTemplate extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Guid */
  actionItemId!: string;
  /** String */
  description!: string;
  /** String(60) */
  name!: string;
  /** Binary */
  rowVersion!: any;
  /** String(160) */
  sms!: string;
}

